import * as firebase from 'firebase'
import { Store } from 'vuex';

export default {
  state: {
    newContent: null,
    loadedContents: []
  },
  mutations: {
    setLoadedContents(state, payload) {
      state.loadedContents = payload
    },
    createContent(state, payload) {
      state.newContent = payload
      state.loadedContents.push(payload)
    },

    approveContent(state, payload) {
      state.loadedContents.push(payload)
      const content = state.loadedContents.find(content => {
        return content.id === payload.id
      })
      if (payload.approved != null) {
        content.approved = payload.approved
      }
    },



    updateContent(state, payload) {
      console.log("updateContent", payload.scaleMode)
      const content = state.loadedContents.find(content => {
        return content.id === payload.id
      })
      if (payload.title) {
        content.title = payload.title
      }
      if (payload.description) {
        content.description = payload.description
      }
      if (payload.date) {
        content.date = payload.date
      }
      if (payload.addTitle) {
        content.showTitle = payload.addTitle
      }
      if (payload.subtitle) {
        content.subtitle = payload.subtitle
      }
      if (payload.footer) {
        content.footer = payload.footer
      }
      if (payload.keywords) {
        content.keywords = payload.keywords
      }
      if (payload.scaleMode) {
        content.scaleMode = payload.scaleMode
      }
      if (payload.videoSize) {
        content.videoSize = payload.videoSize
      }
      if (payload.hideS) {
        content.hideS = payload.hideS
      }
      if (payload.approved != null) {
        content.approved = payload.approved
      }
      if (payload.rating) {
        content.rating = payload.rating
      }
      if (payload.mode) {
        content.mode = payload.mode
      }
      if (payload.status) {
        content.status = payload.status
      }
      state.newContent = content


    }
  },
  actions: {

    loadContents({ commit }) {
      console.log("YYY LOAD CONTENT")
      commit('setLoading', true)
      firebase
        .database()
        .ref('content')
        .once('value')
        .then(data => {
          const contents = []
          const obj = data.val()
          for (let key in obj) {
            contents.push({
              id: key,
              title: obj[key].title,
              subtitle: obj[key].subtitle || null,
              body: obj[key].body || null,
              hideS: obj[key].hideS || null,
              footer: obj[key].footer || null,
              description: obj[key].description,
              approved: obj[key].approved,
              rating: obj[key].rating,
              looping: obj[key].looping,
              duration: obj[key].duration,
              artist: obj[key].author,
              videoUrl: obj[key].videoUrl,
              videoSize: obj[key].videoSize || null,
              imageUrl: obj[key].imageUrl,
              web: obj[key].web,
              date: obj[key].date,
              type: obj[key].type,
              creatorId: obj[key].creatorId,
              keywords: obj[key].keywords || null,
              addTitle: obj[key].addTitle || null,
              scaleMode: obj[key].scaleMode || null,
              mode: obj[key].mode || null,
              status: obj[key].status || 'none'
            })
          }
          commit('setLoading', false)
          commit('setLoadedContents', contents)
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', false)
        })
    },
    createContent({ commit, dispatch, getters }, payload) {
      var store = this;

      const content = {
        title: payload.title,
        author: payload.author,
        image: payload.image,
        video: payload.video,
        videoSize: payload.videoSize || null,
        web: payload.web || null,
        type: payload.type,
        subtitle: payload.subtitle || null,
        body: payload.body || null,
        hideS: payload.hideS || null,
        footer: payload.footer || null,
        description: payload.description || "",
        duration: payload.duration,
        date: payload.date.toISOString(),
        keywords: payload.keywords || null,
        addTitle: payload.addTitle || null,
        scaleMode: payload.scaleMode || null,
        creatorId: getters.user.id,
        mode: payload.mode || null,
        status: payload.status || "none"
      }
      let imageUrl
      let videoUrl
      let contentURL = []
      let key
      let uploads
      let type = payload.type
      let images = [];
      if (type != "title") {
        images.push(payload.image);
      }
      if (type == "video") {
        images.push(payload.video);
      }
      //console.log("UPLOADS", type, images);
      // Reach out to firebase and store it
      firebase
        .database()
        .ref('content')
        .push(content)
        .then(data => {
          console.log(data)
          key = data.key
          return key
        })
        .then(key => {
          console.log("UPLOADS", images.length);
          if (images.length > 0) {
            commit('setUpLoading', true);
            let bytes = {};
            var totalBytes = 0;
            var uploadedBytes = 0;
            uploads = images.map(uploadedImage => {
              console.log(uploadedImage);
              bytes[uploadedImage.size] = 0;
              console.log(bytes);
              totalBytes += uploadedImage.size;
              const filename = uploadedImage.name
              const ext = filename.slice(filename.lastIndexOf('.'))
              const uploadTask = firebase
                .storage()
                .ref('content/' + key + ext)
                .put(uploadedImage)

              // you probably don't need this part
              // since 'progress' is not used anywhere
              uploadTask.on('state_changed', snapshot => {
                bytes[snapshot.totalBytes] = snapshot.bytesTransferred;
                uploadedBytes = 0;
                for (var b in bytes) {
                  uploadedBytes += bytes[b]
                }
                var progress = (uploadedBytes / totalBytes) * 100
                  //var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                console.log(progress + " of " + snapshot.totalBytes, snapshot)
                commit('setProgress', progress);
              })

              return uploadTask.then(snapshot => {
                console.log("URL", snapshot.downloadURL)
                contentURL.push(snapshot.downloadURL)
              })
            })

            // wait for all uploadTasks to be done
            Promise.all(uploads).then(() => {
                //this.createListing()
                console.log("all uploaded", contentURL, key)
                dispatch('assignContentToUser', key)
                commit('setUpLoading', false);
                return contentURL

              }).then(fileData => {
                console.log("videoUrl fileData", fileData);
                //TODO check 0 is image and 1 is video.
                imageUrl = fileData[0]
                videoUrl = null
                if (type == "video") {
                  videoUrl = fileData[1]
                }
                return firebase
                  .database()
                  .ref('content')
                  .child(key)
                  .update({ imageUrl: imageUrl, videoUrl: videoUrl })


              }).then(() => {
                commit('createContent', {
                  ...content,
                  imageUrl: imageUrl,
                  videoUrl: videoUrl,
                  id: key
                })
              })
              .catch(error => {
                console.log(error)
              })
          } else {
            console.log("UPLOAD", key)
            commit('createContent', {
              ...content,
              imageUrl: null,
              videoUrl: null,
              id: key
            })
          }
        })
    },
    replaceImage({ commit }, payload) {
      console.log("replaceImage", payload)
      commit('setLoading', true)
      const filename = payload.image.name
      const ext = filename.slice(filename.lastIndexOf('.'))
      const uploadTask = firebase
        .storage()
        .ref('content/' + payload.id + ext)
        .put(payload.image)

      uploadTask.on('state_changed', function(snapshot) {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log('Upload is ' + progress + '% done');
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log('Upload is paused');
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log('Upload is running');
            break;
        }
      }, function(error) {
        // Handle unsuccessful uploads
      }, function() {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {

          console.log('File available at', downloadURL);
          //commit('updateContent', { imageUrl: downloadURL })
          const updateObj = { imageUrl: downloadURL, status: 'image updated' }
          commit('setLoading', false)

          firebase
            .database()
            .ref('content')
            .child(payload.id)
            .update(updateObj)
            .then(() => {

              commit('updateContent', payload)
            })
            .catch(error => {
              commit('setLoading', false)
              console.log(error)
            })
        });
      });
    },
    replaceVideo({ commit }, payload) {
      console.log("replaceVideo", payload)
      commit('setLoading', true)
      const filename = payload.video.name
      const ext = filename.slice(filename.lastIndexOf('.'))
      const uploadTask = firebase
        .storage()
        .ref('content/' + payload.id + ext)
        .put(payload.video)

      uploadTask.on('state_changed', function(snapshot) {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log('Upload is ' + progress + '% done');
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log('Upload is paused');
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log('Upload is running');
            break;
        }
      }, function(error) {
        // Handle unsuccessful uploads
      }, function() {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {

          console.log('File available at', downloadURL);
          //commit('updateContent', { imageUrl: downloadURL })
          const updateObj = { videoUrl: downloadURL, status: 'video uploaded' }
          commit('setLoading', false)

          firebase
            .database()
            .ref('content')
            .child(payload.id)
            .update(updateObj)
            .then(() => {

              commit('updateContent', payload)
            })
            .catch(error => {
              commit('setLoading', false)
              console.log(error)
            })
        });
      });
    },
    createContentInfo({ commit, dispatch, getters }, payload) {
      var store = this;

      const content = {
        title: payload.title,
        author: payload.author,
        image: payload.image,
        video: payload.video,
        videoSize: payload.videoSize || null,
        web: payload.web || null,
        type: payload.type,
        subtitle: payload.subtitle || null,
        body: payload.body || null,
        hideS: payload.hideS || null,
        footer: payload.footer || null,
        description: payload.description || "",
        duration: payload.duration,
        date: payload.date.toISOString(),
        keywords: payload.keywords || null,
        addTitle: payload.addTitle || null,
        scaleMode: payload.scaleMode || null,
        creatorId: getters.user.id,
        mode: payload.mode || null,
        status: payload.status || "none"
      }
      let imageUrl
      let videoUrl
      let contentURL = []
      let key
      let uploads
      let type = payload.type
      let images = [];
      if (type == "web") {
        images.push(payload.image);
      }
      console.log("UPLOADS", type, images);
      // Reach out to firebase and store it
      firebase
        .database()
        .ref('content')
        .push(content)
        .then(data => {
          console.log(data)
          key = data.key
          return key
        })
        .then(key => {
          console.log("UPLOADS", images.length);
          if (images.length > 0) {
            commit('setUpLoading', true);
            let bytes = {};
            var totalBytes = 0;
            var uploadedBytes = 0;
            uploads = images.map(uploadedImage => {
              console.log(uploadedImage);
              bytes[uploadedImage.size] = 0;
              console.log(bytes);
              totalBytes += uploadedImage.size;
              const filename = uploadedImage.name
              const ext = filename.slice(filename.lastIndexOf('.'))
              const uploadTask = firebase
                .storage()
                .ref('content/' + key + ext)
                .put(uploadedImage)

              uploadTask.on('state_changed', snapshot => {
                bytes[snapshot.totalBytes] = snapshot.bytesTransferred;
                uploadedBytes = 0;
                for (var b in bytes) {
                  uploadedBytes += bytes[b]
                }
                var progress = (uploadedBytes / totalBytes) * 100
                commit('setProgress', progress);
              })

              return uploadTask.then(snapshot => {
                console.log("URL", snapshot.downloadURL)
                contentURL.push(snapshot.downloadURL)
              })
            })

            // wait for all uploadTasks to be done
            Promise.all(uploads).then(() => {
                //this.createListing()
                console.log("all uploaded", contentURL, key)
                dispatch('assignContentToUser', key)
                commit('setUpLoading', false);
                return contentURL

              }).then(fileData => {
                console.log("videoUrl fileData", fileData);
                //TODO check 0 is image and 1 is video.
                imageUrl = fileData[0]
                videoUrl = null
                if (type == "video") {
                  videoUrl = fileData[1]
                }
                return firebase
                  .database()
                  .ref('content')
                  .child(key)
                  .update({ imageUrl: imageUrl, videoUrl: videoUrl })


              }).then(() => {
                commit('createContent', {
                  ...content,
                  imageUrl: imageUrl,
                  videoUrl: videoUrl,
                  id: key
                })
              })
              .catch(error => {
                console.log(error)
              })
          } else {
            console.log("UPLOAD", key)
            commit('createContent', {
              ...content,
              imageUrl: null,
              videoUrl: null,
              id: key
            })
          }
        })
    },
    replaceImage({ commit }, payload) {
      console.log("replaceImage", payload)
      commit('setLoading', true)
      const filename = payload.image.name
      const ext = filename.slice(filename.lastIndexOf('.'))
      const uploadTask = firebase
        .storage()
        .ref('content/' + payload.id + ext)
        .put(payload.image)

      uploadTask.on('state_changed', function(snapshot) {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log('Upload is ' + progress + '% done');
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log('Upload is paused');
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log('Upload is running');
            break;
        }
      }, function(error) {
        // Handle unsuccessful uploads
      }, function() {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {

          console.log('File available at', downloadURL);
          //commit('updateContent', { imageUrl: downloadURL })
          const updateObj = { imageUrl: downloadURL, status: 'image updated' }
          commit('setLoading', false)

          firebase
            .database()
            .ref('content')
            .child(payload.id)
            .update(updateObj)
            .then(() => {

              commit('updateContent', payload)
            })
            .catch(error => {
              commit('setLoading', false)
              console.log(error)
            })
        });
      });
    },
    updateContentData({ commit }, payload) {
      console.log("updateContentData", payload)
      commit('setLoading', true)
      const updateObj = {}
      if (payload.title) {
        updateObj.title = payload.title
      }
      if (payload.description) {
        updateObj.description = payload.description
      }
      if (payload.author) {
        updateObj.author = payload.author
      }
      if (payload.artist) {
        updateObj.author = payload.artist
      }
      if (payload.duration) {
        updateObj.duration = payload.duration
      }
      if (payload.date) {
        updateObj.date = payload.date
      }
      if (payload.approved != null) {
        updateObj.approved = payload.approved
      }
      if (payload.rating) {
        updateObj.rating = payload.rating
      }
      if (payload.keywords) {
        updateObj.keywords = payload.keywords
      }
      if (payload.subtitle) {
        updateObj.subtitle = payload.subtitle
      }
      if (payload.scaleMode) {
        updateObj.scaleMode = payload.scaleMode
      }
      if (payload.footer) {
        updateObj.footer = payload.footer
      }
      if (payload.status) {
        updateObj.status = payload.status
      }
      firebase
        .database()
        .ref('content')
        .child(payload.id)
        .update(updateObj)
        .then(() => {
          commit('setLoading', false)
          commit('updateContent', payload)
        })
        .catch(error => {
          commit('setLoading', false)
          console.log(error)
        })
    }

  },
  getters: {
    newContent(state) {
      return state.newContent
    },
    loadedContents(state) {
      return state.loadedContents.sort(function(contentA, contentB)  {
        let d1= new Date(contentA.date)
        let d2 = new Date(contentB.date)
        return d2.getTime() - d1.getTime()
      })
    
    },

    featuredContents(state, getters) {
      return getters.loadedContents.slice(0, 5)
    },
    loadedContent(state) {

      return contentId => {
        return state.loadedContents.find(content => {
          return content.id === contentId
        })
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/content/index.js